module.exports = __webpack_public_path__ + "static/blueknittedbear-ff9baac43619e2bcc6c0c7769bcd744c.jpeg";